/**
 * Format shortly big numbers with k, m, b
 * @param num
 * @param precision
 */
export function numericalFormatterSplitted(
  num: number | string,
  precision = 4
): [string, string] {
  if (typeof num === 'string') {
    num = parseFloat(num)
  }
  if (num >= 1000000000) {
    return [(num / 1000000000).toPrecision(precision).replace(/\.0$/, ''), 'b']
  }
  if (num >= 1000000) {
    return [(num / 1000000).toPrecision(precision).replace(/\.0$/, ''), 'm']
  }
  if (num >= 1000) {
    return [(num / 1000).toPrecision(precision).replace(/\.0$/, ''), 'k']
  }
  return [num.toPrecision(precision), '']
}
/**
 * Format shortly big numbers with k, m, b
 * @param num
 * @param precision
 */
export function numericalFormatter(
  num: number | string,
  precision = 4
): string {
  const [value, format] = numericalFormatterSplitted(num, precision)
  return value + format
}

export function isNumericString(str: string | undefined): boolean {
  if (typeof str !== 'string') return false // we only process strings!
  if (str === '') {
    return false
  }
  return (
    !isNaN(str as any) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
    !isNaN(Number(str))
  ) // ...and ensure strings of whitespace fail
}

/**
 * Same as isNumeric() but with no exposant
 * @param str
 */
export function isSimpleNumericString(str: string | undefined): boolean {
  return isNumericString(str) && !str!.includes('e')
}
